// extracted by mini-css-extract-plugin
module.exports = {"buttonsWrapper":"WorkoutsOfferSuccess_buttonsWrapper__3mUup","submitButton":"WorkoutsOfferSuccess_submitButton__1Nyxk"};